<template>
  <section
    ref="container"
    id="hero"
    class="relative hero-background overflow-hidden py-[72px] md:py-[102px] min-h-[650px] md:min-h-[800px] flex lg:items-start items-center justify-between lg:justify-center lg:flex-row flex-col"
  >
    <CommonCoin
      id="left-icons-1"
      image="/landing/coins/ada.svg"
      rotate-position="left"
      class="absolute left-[20%] top-[40%] z-40 !hidden lg:!block"
    />
    <CommonCoin
      id="left-icons-2"
      image="/landing/coins/avax.svg"
      rotate-position="left"
      class="absolute left-[5%] top-[60%] z-40 !hidden lg:!block"
    />
    <CommonCoin
      id="left-icons-3"
      image="/landing/coins/btc.svg"
      rotate-position="left"
      class="absolute left-[5%] top-[20%] z-40 !hidden lg:!block"
    />
    <CommonCoin
      id="left-icons-4"
      image="/landing/coins/eth.svg"
      rotate-position="right"
      class="absolute right-[20%] top-[40%] z-40 !hidden lg:!block"
    />
    <CommonCoin
      id="left-icons-5"
      image="/landing/coins/sol.svg"
      rotate-position="right"
      class="absolute right-[5%] top-[60%] z-40 !hidden lg:!block"
    />
    <CommonCoin
      id="left-icons-6"
      image="/landing/coins/xrp.svg"
      rotate-position="right"
      class="absolute right-[5%] top-[20%] z-40 !hidden lg:!block"
    />
    <CommonHeroTitle />
    <div
      id="wrapper"
      class="absolute top-[60%] left-1/2 -translate-x-1/2 w-full z-40 !hidden lg:!block"
    >
      <CommonDesktop id="desktop" />
    </div>
    <div class="lg:!block !hidden">
      <CommonLogo
        class="absolute top-[70%] left-1/2 -translate-x-1/2"
        id="logo"
      />
    </div>
    <div class="lg:!hidden w-full h-full relative flex-y-center justify-center">
      <CommonLogo class="relative z-50" id="logo" />
      <CommonCoin
        id="left-icons-1"
        image="/landing/coins/ada.svg"
        rotate-position="left"
        class="absolute left-[5%] top-[45%] sm:left-[20%] sm:top-[40%] z-40 w-14 h-14 sm:h-16 sm:w-16"
      />
      <CommonCoin
        id="left-icons-2"
        image="/landing/coins/avax.svg"
        rotate-position="left"
        class="absolute left-[12%] bottom-[-20%] sm:left-[5%] sm:bottom-0 z-40"
      />
      <CommonCoin
        id="left-icons-3"
        image="/landing/coins/btc.svg"
        rotate-position="left"
        class="absolute bottom-[-10%] left-[-10%] sm:left-[5%] sm:top-0 z-40"
      />
      <CommonCoin
        id="left-icons-4"
        image="/landing/coins/eth.svg"
        rotate-position="right"
        class="absolute right-[5%] top-[45%] sm:right-[20%] sm:top-[40%] z-40 w-14 h-14 sm:h-16 sm:w-16"
      />
      <CommonCoin
        id="left-icons-5"
        image="/landing/coins/sol.svg"
        rotate-position="right"
        class="absolute right-[12%] bottom-[-20%] sm:right-[5%] sm:bottom-0 z-40"
      />
      <CommonCoin
        id="left-icons-6"
        image="/landing/coins/xrp.svg"
        rotate-position="right"
        class="absolute bottom-[-10%] right-[-10%] sm:right-[5%] sm:top-0 z-40"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import gsap from "gsap";
import CommonCoin from "@/modules/Landing/components/Common/Coin.vue";
import CommonLogo from "@/modules/Landing/components/Common/Logo.vue";
import CommonHeroTitle from "@/modules/Landing/components/Common/HeroTitle.vue";
import CommonDesktop from "@/modules/Landing/components/Common/Desktop.vue";

import ScrollTrigger from "gsap/ScrollTrigger";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";

function desktopAnimation() {
  gsap.fromTo(
    "#left-icons-1",
    { opacity: 0, x: -150 },
    {
      opacity: 1,
      x: 0,
      duration: 1.2,
      delay: 0.2,
    },
  );
  gsap.fromTo(
    "#left-icons-2",
    { opacity: 0, x: -150 },
    {
      opacity: 1,
      x: 0,
      duration: 1.2,
      delay: 0.3,
    },
  );
  gsap.fromTo(
    "#left-icons-3",
    { opacity: 0, x: -150 },
    {
      opacity: 1,
      x: 0,
      duration: 1.2,
      delay: 0.5,
    },
  );
  gsap.fromTo(
    "#left-icons-4",
    { opacity: 0, x: 150 },
    {
      opacity: 1,
      x: 0,
      duration: 1.2,
      delay: 0.2,
    },
  );
  gsap.fromTo(
    "#left-icons-5",
    { opacity: 0, x: 150 },
    {
      opacity: 1,
      x: 0,
      duration: 1.2,
      delay: 0.3,
    },
  );
  gsap.fromTo(
    "#left-icons-6",
    { opacity: 0, x: 150 },
    {
      opacity: 1,
      x: 0,
      duration: 1.2,
      delay: 0.5,
    },
  );
  gsap.fromTo(
    "#wrapper",
    { opacity: 0, y: 150, delay: 1.2 },
    {
      opacity: 1,
      y: 0,
      delay: 1.2,
    },
  );
  gsap.fromTo(
    "#logo",
    { opacity: 0, y: 150 },
    {
      opacity: 1,
      y: 0,
      delay: 1.4,
    },
  );
  gsap.to("#desktop", {
    scrollTrigger: {
      trigger: "#desktop",
      start: "-50px center",
      end: "140px center",
      scrub: 4,
      toggleActions: "play resume reverse none",
    },
    lazy: true,
    y: 550,
  });
  gsap.set("#hero", { perspective: 500 });
}

onMounted(() => {
  if (typeof window !== "undefined") {
    gsap.registerPlugin(ScrollTrigger);
    gsap.registerPlugin(MotionPathPlugin);
    desktopAnimation();
  }
});
</script>

<style scoped>
.hero-background {
  background: linear-gradient(
    180deg,
    #ffffff 40.75%,
    rgba(244, 246, 229, 0.89)
  );
}
</style>
